module.exports = __webpack_public_path__ + "public/images/calendar-header-meet.4687fa14e352e2616cb7d5493361648e.svg";